
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCreatePushNotificationTokenDto } from '../models/work-create-push-notification-token-dto';

export function getCreateAppDeviceDtoFormGroup() {
return new FormGroup({
    uniqueIdentifier: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    platform: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    osVersion: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    model: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    appVersion: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    pushNotificationDto: new FormControl<WorkCreatePushNotificationTokenDto | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
})
;
}
      